module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-label-aling"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.alignment')))]), _vm._v(" "), _c('select', {
    staticClass: "klickart-select"
  }, [_c('option', {
    attrs: {
      "value": "none"
    },
    domProps: {
      "selected": _vm.value() === 'none'
    }
  }, [_vm._v(_vm._s(_vm.$t('general.labels.center')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "left"
    },
    domProps: {
      "selected": _vm.value() === 'left'
    }
  }, [_vm._v(_vm._s(_vm.$t('general.labels.left')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "right"
    },
    domProps: {
      "selected": _vm.value() === 'right'
    }
  }, [_vm._v(_vm._s(_vm.$t('general.labels.right')))])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a6f9b6a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/triggerbutton/Align.vue
 ** module id = 898
 ** module chunks = 1
 **/